import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Column - Stacked logo like Figma */}
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/logo.png" alt="TheyChat" className="footer-logo-img" />
          </Link>
          <p className="footer-desc">
            {t(
              'footer.description',
              'TheyChat is an AI-powered educational platform that simulates conversations with historical figures based on documented historical sources.',
            )}
          </p>
        </div>

        {/* Columns Container */}
        <div className="footer-columns">
          {/* Pages Column */}
          <div className="footer-section pages">
            <h4>{t('footer.pages', 'Pages')}</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">{t('header.home', 'Home')}</Link>
              </li>
              <li>
                <Link to="/about">{t('header.aboutUs', 'About Us')}</Link>
              </li>
              <li>
                <Link to="/sponsor">{t('header.sponsor', 'Sponsor')}</Link>
              </li>
              <li>
                <Link to="/subscription">{t('header.subscription', 'Subscription')}</Link>
              </li>
              <li>
                <Link to="/faq">{t('header.faq', 'FAQ')}</Link>
              </li>
            </ul>
          </div>

          {/* Information Column */}
          <div className="footer-section information">
            <h4>{t('footer.information', 'Information')}</h4>
            <ul className="footer-links">
              <li>
                <Link to="/contact">{t('header.contactUs', 'Contact Us')}</Link>
              </li>
              <li>
                <Link to="/privacy">{t('footer.privacyPolicy', 'Privacy Policy')}</Link>
              </li>
              <li>
                <Link to="/terms">{t('footer.terms', 'Terms of Service')}</Link>
              </li>
              <li>
                <Link to="/disclaimer">{t('disclaimer.title', 'Disclaimer')}</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <title>Copyright Icon</title>
            <circle cx="12.5" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
            <text x="12.5" y="16" textAnchor="middle" fontSize="12" fill="currentColor">
              ©
            </text>
          </svg>
          <span>
            {t('footer.copyright', 'CopyRight')} {currentYear},{' '}
            {t('footer.allRightsReserved', 'All rights reserved')}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
